module.exports = __webpack_public_path__ + "front/img/83.6640013c.png";